export default __webpack_public_path__ + "static/media/woman-logo.aafb341b.svg";